/**
 * Formatea un shipment de stock orders para ser usado en los modales de delivery compartidos
 * @param shipment Shipment de stock orders a formatear
 * @returns Shipment formateado según la interfaz IStockOrderShipmentFormatted
 */
import { ObjectKey } from '../types/pills';
import { IProductDelivery } from '../types/orders';
import { IStockOrderDetail, IStockOrderShipmentFormatted } from '../types/stockOrders';

export const formatShipmentForDelivery = (
  shipment: IStockOrderDetail['generalData']['shipments'][number]
): IStockOrderShipmentFormatted => ({
  shipmentId: shipment.stockShipmentId,
  stockShipmentUuid: shipment.stockShipmentUuid,
  unit: shipment.quantity,
  products: shipment.items.map(item => ({
    id: item.productId,
    name: shipment.product.name,
    pills: shipment.product.pills as unknown as ObjectKey<string>,
    sku: shipment.product.sku,
    units: shipment.quantity,
    serial: item.serial
  })) as IProductDelivery[],
  status: shipment.status,
  statusId: shipment.statusId,
  trackingInfo: {
    estimatedDeliveryDate: shipment?.tracking?.estimatedDeliveryDate || null,
    trackingLink: shipment?.tracking?.trackingLink || null,
    trackerNumber: shipment?.tracking?.trackingCode || null,
    currentEstimatedDeliverDate: shipment?.tracking?.estimatedDeliveryDate || null
  },
  country: shipment.country
});
